import React, { useState } from "react";
import { Box } from "@mui/material";
import Header from "../../components/global/Header";
import PricingComponent from "../../components/subscriberComponents/PricingComponent";
import { changePlan } from "../../data/PricingData";

// const Buttons = {
//   nonsubscribed: {
//     buttonText: "Buy this plan",
//     path: "/subscriber/plan/get/botlink",
//   },
//   subscribed: {
//     buttonText: "Manage Subscription",
//     path: "/subscriber/plan/manage/subscription",
//   },
// };

function ChangePlan({ isSubscribe }) {
  const allTiers = changePlan();
  console.log("AllTiers", allTiers);

  return (
    <>
      {isSubscribe == true ? (
        <Box m={"2vw"}>
          <Header
            title={"Subscription Plan"}
            subTitle={"Choose Subscription Plan"}
          />
          <PricingComponent buttons={Buttons} tiers={allTiers} />
        </Box>
      ) : (
        <Box m="2vw">
          <Header subTitle="No Access" />
        </Box>
      )}
    </>
  );
}

export default ChangePlan;
